import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdvancedFilterService } from './advanced-filter.service';

@Component({
  selector: 'advanced-filter',
  templateUrl: './advanced-filter.component.html',
  styleUrls: ['./advanced-filter.component.scss'],
  providers: [AdvancedFilterService],
})
export class AdvancedFilterComponent implements OnInit {
  states: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    // { code: 'AP', name: 'Andhra Pradesh' },
  ];
  statesFresh: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'OD', name: 'Odisha' },
    { code: 'TN', name: 'Tamilnadu' },
    { code: 'AD', name: 'Andhra Pradesh' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'MH', name: 'Maharashtra' }

  ];
  statesRenewal: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    // { code: 'AP', name: 'Andhra Pradesh' },
  ];
  selectedFilters: any;
  selectedState: string;
  selectedZone: string;
  selectedRegion: string;
  selectedBranch: string;
  selectedDates: { from: string; to: string } = { from: '', to: '' };
  selectedDatesType: string;
  zones: Array<any>;
  regions: Array<any>;
  branches: Array<any>;
  routeApiIdentifier: string = 'wEnlw3OeU3';
  routeApiKeys: Array<any> = [
    {
      value: 'MP',
      key: 'xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1',
    },
    {
      value: 'KA',
      key: 'KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y',
    },
    {
      value: 'AP',
      key: 'X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6',
    },
    {
      value: 'UP',
      key: 'Uq4YVODcoCruRMHy8lCFRPFbAf8d4uP8',
    },
    {
      value: 'OD',
      key:'2HeSroDFbNjOyhnwVO4WV90Gu2ET1QsZ'
    },
    {
      value: 'TN',
      key:'tNteP4U71cOhlWNlpGF5F9vkWkUFtmMy'
    },
    {
      value: 'AD',
      key: 'X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6'
    },
     {
      value: 'RJ',
      key: 'Rs3dWqiFcIvLvRNFneH8wSRduQF28UhJ'
    },
    {
      value: 'GJ',
      key: 'gXpj9Y7qw1U5Jp6tdn4vkqduvnMZEjJJ'
    },
    {
      value: 'MH',
      key: 'fPWMHrmB1qRhPu2bOIT9LlGcAugp8cM6'
    }
  ];
  dropDownResults: any = {};

  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

  @Input()isDashboard;
  @Input()showOnlyStateAndDate: boolean = false;
  @Input()showOnlyState: boolean = false;

  createdValue:any;
  sanctionedValue:any;
  disableSubmitInitially: boolean;
  isDateFilterInvalid: boolean = false;

  constructor(private advancedFilterService: AdvancedFilterService) {}

  ngOnInit() {
      // window.alert(window.location.href)
      let currentUrl = window.location.href;
      // window.alert(currentUrl.split('/')[currentUrl.split('/').length-2])
      let path = currentUrl.split('/')[currentUrl.split('/').length-2]
      if(path=="fresh-app"){
        this.states = this.statesFresh;
      }else if(path=="admin"){
        
      }

    this.selectedFilters = this.advancedFilterService.getFilterData();
    if (this.selectedFilters) {
      if (this.selectedFilters.state_copy) {
        this.selectedState = this.selectedFilters.state_copy;
        this.selectState();
        this.setSessionStorage();
      }

      if (this.selectedFilters.zone_copy) {
        this.selectedZone = this.selectedFilters.zone_copy;
        this.selectZone();
      }

      if (this.selectedFilters.region_copy) {
        this.selectedRegion = this.selectedFilters.region_copy;
        this.selectRegion();
      }

      if (this.selectedFilters.branch_copy) {
        this.selectedBranch = this.selectedFilters.branch_copy;
        this.selectBranch();
      }
    }
    console.log("isDashboard",this.isDashboard);
    sessionStorage.removeItem('createdOrSanctionedDate');
    this.disableSubmitInitially = true;

  }

  clearZone() {
    this.selectedZone = '';
  }

  clearRegion() {
    this.selectedRegion = '';
  }

  clearBranch() {
    this.selectedBranch = '';
  }

  clearZRBList() {
    this.clearZone();
    this.zones = [];
    this.clearRegion();
    this.regions = [];
    this.clearBranch();
    this.branches = [];
  }

  selectState() {
    this.clearZRBList();
    this.submitForm(true);
    sessionStorage.setItem(
      this.routeApiIdentifier,
      this.routeApiKeys.find((route) => route.value === this.selectedState).key
    );
    debugger
    sessionStorage.setItem('stateCode', this.selectedState);
    sessionStorage.setItem('stateCode', this.selectedZone)
    this.dropDownResults = {};
    this.advancedFilterService.getDropDownValues().subscribe((response: any) => {
      if (response && response.message === 'success') {
        this.dropDownResults = response.result;
        for (const zoneName in response.result) {
          const zone = response.result[zoneName];
          if (zoneName && zoneName !== 'undefined')
            this.zones.push({ name: zoneName, code: zone.zonal_code });
        }
        if (this.zones.length) this.zones.unshift({ code: 'ALL_ZONES', name: 'All Zones' });
      }
    });
  }

  setSessionStorage(){
    console.log(this.selectedState)
    sessionStorage.setItem('stateCode',this.selectedState)
  };

  async selectZone() {
    this.clearRegion();
    this.regions = [];
    this.clearBranch();
    this.branches = [];
    this.submitForm(true);
    let regions = {};

    if (!Object.keys(this.dropDownResults).length) {
      const dropDownResults = await new Promise((resolve, reject) => {
        this.advancedFilterService.getDropDownValues().subscribe((response: any) => {
          if (response && response.message === 'success') {
            resolve(response.result);
          } else {
            reject('Error fetching dropDownValues');
          }
        });
      });
      this.dropDownResults = dropDownResults
    }

    for (const zoneName in this.dropDownResults) {
      const zone = this.dropDownResults[zoneName];
      if (zone.zonal_code === this.selectedZone) {
        regions = { ...zone.regions };
        break;
      }
    }

    for (const regionName in regions) {
      const region = regions[regionName];
      if (regionName && regionName !== 'undefined')
        this.regions.push({ name: regionName, code: region.ro_code });
    }
    
    if (this.regions.length) this.regions.unshift({ code: 'ALL_REGIONS', name: 'All Regions' });
  }

  async selectRegion() {
    this.clearBranch();
    this.branches = [];
    this.submitForm(true);

    let branches = [];
    if (!Object.keys(this.dropDownResults).length) {
      const dropDownResults = await new Promise((resolve, reject) => {
        this.advancedFilterService.getDropDownValues().subscribe((response: any) => {
          if (response && response.message === 'success') {
            resolve(response.result);
          } else {
            reject('Error fetching dropDownValues');
          }
        });
      });
      this.dropDownResults = dropDownResults;
    }

    for (const zoneName in this.dropDownResults) {
      const zone = this.dropDownResults[zoneName];
      for (const regionName in zone.regions) {
        const region = zone.regions[regionName];
        if (region.ro_code === this.selectedRegion) {
          branches = [...region.branches];
        }
      }
    }

    for (const branch of branches) {
      this.branches.push({ name: branch.branch_name, code: branch.branch_code });
    }

    if (this.branches.length) this.branches.unshift({ code: 'ALL_BRANCHES', name: 'All Branches' });
  }

  selectBranch() {
    this.submitForm(true);
  }

  onDateRangeChange(values: any) {
    this.isDateFilterInvalid = values.invalid;

    if (this.isDateFilterInvalid) {
      this.submitForm(true);
      return;
    }

    if (values.option === 'month') {
      const selectedMonth = new Date(values.value);
      const startOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth(), 1);
      const endOfMonth = new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 0);

      this.selectedDates.from = this.formatDate(startOfMonth);
      this.selectedDates.to = this.formatDate(endOfMonth);
    }

    if (values.option === 'date') {
      this.selectedDates.from = this.selectedDates.to = this.formatDate(new Date(values.value));
    }

    if (values.option === 'dateRange') {
      this.selectedDates.from = this.formatDate(new Date(values.value.from));
      this.selectedDates.to = this.formatDate(new Date(values.value.to));
    }

    this.selectedDatesType = values.option;
    this.submitForm(true);
  }

  formatDate(date: any) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  isButtonDisabled() {
    return !this.selectedState || this.isDateFilterInvalid;
  }

  isZoneDropdownDisabled() {
    if (!this.selectedState || !this.zones.length || this.selectedState === 'ALL_STATES') {
      return true;
    }
    return false;
  }

  isRegionDropdownDisabled() {
    if (
      !this.selectedState ||
      !this.selectedZone ||
      !this.regions.length ||
      this.selectedZone === 'ALL_ZONES' ||
      this.selectedState === 'ALL_STATES'
    ) {
      return true;
    }
    return false;
  }

  isBranchDropdownDisabled() {
    if (
      !this.selectedState ||
      !this.selectedRegion ||
      !this.branches.length ||
      this.selectedRegion === 'ALL_REGIONS' ||
      this.selectedState === 'ALL_STATES'
    ) {
      return true;
    }
    return false;
  }

  submitForm(internalCall: boolean = false) {
    const formData = {
      state: this.selectedState,
      state_copy: this.selectedState,
      zone: this.selectedZone,
      zone_copy: this.selectedZone,
      region: this.selectedRegion,
      region_copy: this.selectedRegion,
      branch: this.selectedBranch,
      branch_copy: this.selectedBranch,
      date: this.selectedDates,
      dateType: this.selectedDatesType,
    };
    formData.zone = this.selectedZone === 'ALL_ZONES' ? '' : this.selectedZone;
    formData.region = this.selectedRegion === 'ALL_REGIONS' ? '' : this.selectedRegion;
    formData.branch = this.selectedBranch === 'ALL_BRANCHES' ? '' : this.selectedBranch;
    this.advancedFilterService.setFilterData(formData);
    !internalCall && this.onSubmit.emit(formData);
  }

  onCheckboxChange(type){
    console.log(type);
    this.disableSubmitInitially = false;
    sessionStorage.setItem('createdOrSanctionedDate',type);
    if(type=="sanctioned"){
      this.createdValue = "";
    }else{
      this.sanctionedValue = "";
    }
  }
}
